interface ListUserHeaderTable {
  headerName: string;
}

export const HeaderTable: ListUserHeaderTable[] = [
  { headerName: "Nome" },
  { headerName: "E-mail" },
  { headerName: "Razão social" },
  { headerName: "Tipo de usuário" },
  { headerName: "Cadastrado por" },
  { headerName: "Data de cadastro" },
  { headerName: "" },
];
